import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { Task, User } from "@/types/v2";

import { convertStringHumanReadable } from "@/utils/v2";

import ModalBox from "@/components/v2/Modal/ModalBox.vue";

interface TaskStartModalProps {
    show: boolean;
    task: Task;
    currentUser: User | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskStartModal',
  props: {
    show: { type: Boolean },
    task: {},
    currentUser: {}
  },
  emits: ["start", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const start = () => {
    emit("start", props.task)
};
const close = () => {
    emit("close")
};

return (_ctx: any,_cache: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createBlock(ModalBox, {
        key: 0,
        onClose: close
      }, {
        header: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(convertStringHumanReadable)(_ctx.task.objective as string)) + " ", 1),
          (_ctx.task.additionalTitle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.task.additionalTitle) + ")", 1))
            : _createCommentVNode("", true),
          (_ctx.task.studyTitle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, ": " + _toDisplayString(_ctx.task.studyTitle), 1))
            : _createCommentVNode("", true),
          (_ctx.task.status === 'finished')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "- Completed"))
            : _createCommentVNode("", true)
        ]),
        main: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_ctx.task.description), 1)
        ]),
        footer: _withCtx(() => [
          (_ctx.task.status !== 'finished')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "disabled:opacity-25 text-white bg-primary hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center",
                type: "button",
                onClick: start
              }, " Start "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10",
            type: "button",
            onClick: close
          }, " Close ")
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})